function isPlainLeftClick(event) {
	return (
		event.button === 0 &&
		!event.metaKey &&
		!event.ctrlKey &&
		!event.shiftKey &&
		!event.altKey
	);
}

function getContent(documentFragment) {
	return documentFragment.querySelector('[data-page-content]');
}

function shouldHandleLink(link, url) {
	return (
		url.origin === window.location.origin &&
		link.target !== '_blank' &&
		!link.hasAttribute('download') &&
		!link.hasAttribute('data-no-soft-navigation') &&
		url.pathname !== window.location.pathname
	);
}

async function replacePage(url, { pushState = true } = {}) {
	const response = await fetch(url, {
		headers: {
			'X-Requested-With': 'fetch',
		},
	});

	if (!response.ok) {
		throw new Error(`Failed to load ${url}: ${response.status}`);
	}

	const html = await response.text();
	const nextDocument = new DOMParser().parseFromString(html, 'text/html');
	const nextContent = getContent(nextDocument);
	const currentContent = getContent(document);

	if (!nextContent || !currentContent) {
		window.location.assign(url);
		return;
	}

	document.title = nextDocument.title;
	document.body.className = nextDocument.body.className;
	currentContent.replaceWith(nextContent);

	if (pushState) {
		window.history.pushState({}, '', url);
	}

	window.dispatchEvent(new CustomEvent('sacred-scribes:navigate'));

	if (url.hash) {
		document.getElementById(url.hash.slice(1))?.scrollIntoView();
	} else {
		window.scrollTo({ top: 0, left: 0 });
	}
}

export default function softNavigation() {
	if (window.__softNavigationReady) {
		return;
	}

	window.__softNavigationReady = true;
	window.sacredScribesNavigate = (url) =>
		replacePage(new URL(url, window.location.href));

	document.addEventListener('click', (event) => {
		if (!isPlainLeftClick(event)) {
			return;
		}

		const link = event.target.closest('a[href]');

		if (!link) {
			return;
		}

		const url = new URL(link.href);

		if (!shouldHandleLink(link, url)) {
			return;
		}

		event.preventDefault();
		replacePage(url).catch(() => {
			window.location.assign(url);
		});
	});

	window.addEventListener('popstate', () => {
		replacePage(new URL(window.location.href), { pushState: false }).catch(
			() => {
				window.location.reload();
			},
		);
	});
}
